import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular/lazy';
import { CartService } from "../../services/cart.service";
import { Decimal } from 'decimal.js';

@Component({
    selector: 'app-checkout-payment-bank-transfer',
    templateUrl: './checkout-payment-bank-transfer.page.html',
    styleUrls: ['./checkout-payment-bank-transfer.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutPaymentBankTransferPage implements OnInit {

    cart = null;
    payment_amount = null;
    segment = "";

    payment = {
        method: 'bank_transfer',
        price: null,
        label:'Bank transfer'
    };

    params = {
        fulfilled: true,
        awaiting_payment_method: 'bank_transfer'
    };

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private cartService: CartService,
    ) { }

    ngOnInit() {

        this.cartService.get().then((cart) => {
            if (cart) {
                this.cart = cart;
                this.payment_amount = this.cart['amount_due'].toFixed(2);
                this.payment.price = this.cart['amount_due'];
                this.params['fulfilled'] = this.cart['fulfilled'];
            }
        });        

        // set default segment view
        this.segment = 'has_paid';

    }

    sanitisePaymentAmount() {

        let payment_amount = this.payment_amount.toString();
        
        // only accept numbers/decimal points
        if(/[^0-9.]/.test(payment_amount)) {
            this.payment.price = null;
        }        
        else if(payment_amount.startsWith('.')) {
            this.payment.price = null;
        }
        else if(payment_amount.endsWith('.')) {
            this.payment.price = null;
        }        
        else if(payment_amount.split('.').length > 2) {
            this.payment.price = null;
        }
        else if(!payment_amount.length) {
            this.payment.price = null;
        }
        else {
            this.payment.price = Number(new Decimal(payment_amount).toDecimalPlaces(2));
        }

    }    

    addPayment() {

        // ensure payment isn't over the amount due
        if(this.payment.price > this.cart.amount_due) {
            this.payment.price = this.cart.amount_due;
        }
        
        this.cartService.addPayment(this.payment).then(() => {
            this.modalController.dismiss();
        });

    }

    placeOrder() {
        this.modalController.dismiss(this.params);
    }    

    close() {
        this.modalController.dismiss();
    }

}
